import * as React from "react";
export const BriefcaseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.33333 14V4.66667C5.33333 4.04669 5.33333 3.7367 5.40148 3.48236C5.58642 2.79218 6.12551 2.25308 6.8157 2.06815C7.07003 2 7.38002 2 8 2C8.61998 2 8.92997 2 9.1843 2.06815C9.87449 2.25308 10.4136 2.79218 10.5985 3.48236C10.6667 3.7367 10.6667 4.04669 10.6667 4.66667V14M3.46667 14H12.5333C13.2801 14 13.6534 14 13.9387 13.8547C14.1895 13.7268 14.3935 13.5229 14.5213 13.272C14.6667 12.9868 14.6667 12.6134 14.6667 11.8667V6.8C14.6667 6.05326 14.6667 5.6799 14.5213 5.39468C14.3935 5.1438 14.1895 4.93982 13.9387 4.81199C13.6534 4.66667 13.2801 4.66667 12.5333 4.66667H3.46667C2.71993 4.66667 2.34656 4.66667 2.06135 4.81199C1.81046 4.93982 1.60649 5.1438 1.47866 5.39468C1.33333 5.6799 1.33333 6.05326 1.33333 6.8V11.8667C1.33333 12.6134 1.33333 12.9868 1.47866 13.272C1.60649 13.5229 1.81046 13.7268 2.06135 13.8547C2.34656 14 2.71993 14 3.46667 14Z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default BriefcaseIcon;
